<template>
  <div class="barTop bar-top-white">
    <div class="options">
      <a href="/home" class="logo left">
        <!-- <img src="@/assets/images/up.png" /> -->
        <label class="logo">
          play
        </label>
      </a>
      <div class="right align-items-center">
        <div class="openNotifications " @click="openNotifications('NOTIFICATION')" v-click-outside="hideNotification">
          <div v-if="this.readMessagesCount > 0" class="unread-notifications">
            <span>{{ this.readMessagesCount }}</span>
          </div>
          <img src="@/assets/images/clopotel-notificari.svg" />
          <div class="notification-box" v-show="isOpenNotification">
            <div v-if="this.customerMessages === null || this.customerMessages === undefined
              ">
              <div class="notification-wrapper">
                <!-- <img src="@/assets/images/loading.gif" /> -->
              </div>
            </div>
            <div v-if="this.customerMessages && this.customerMessages.length > 0">
              <NotificationsBox :notifications="this.customerMessages" />
            </div>
            <div v-if="this.customerMessages && this.customerMessages.length === 0" class="noNotifications">
              <p>{{ $t("cmsLang.notificationMessage") }}</p>
            </div>
          </div>
        </div>
        <div>
          <a :href="'/profile'">
            <div class="contact-details-wrapper">
              <div class="text">
                <img class="square-32 border-round" :src="this.getImagePath() +
                  'users/user_' +
                  this.user.id +
                  '.png'
                  " @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" w />
                <p>
                  {{
                    this.user.first_name +
                    " " +
                    this.user.last_name
                  }}

                </p>
                <br clear="all" />
                <p>
                  {{
                    this.user.email
                  }}
                </p>
              </div>
            </div>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-play.js";
import ClickOutside from "vue-click-outside";
// import LanguageBar from "@/components/LanguageBar.vue";
import NotificationsBox from "@/components/NotificationsBox.vue";

export default {
  name: "TopBarCompany",
  props: {
    // user: Object,
    company: Object,
  },
  directives: {
    ClickOutside,
  },
  components: {
    // LanguageBar,
    NotificationsBox,
  },
  data() {
    return {
      customerMessages: null,
      menuSelected: {
        faq: false,
        account: false,
      },
      userLink: "",
      token: "",
      readMessagesCount: 0,
      isOpenNotification: false,
      isOpenCompany: false,
      isOpen: false,
      // selectedCompany: this.user.companies[0],
      dataLoaded: false,
    };
  },
  methods: {
    openUserMenu() {
      this.isOpen = !this.isOpen;
    },
    openNotifications(windowType) {
      if (windowType === "NOTIFICATION") {
        this.loadMessages();
        this.isOpenNotification = !this.isOpenNotification;
        this.isOpenCompany = false;
      }
      if (windowType === "COMPANY") {
        this.isOpenCompany = !this.isOpenCompany;
        this.isOpenNotification = false;
      }
    },
    // isReadNotification(message) {
    //   message.read = true;
    //   httpServiceCustomer.customerService
    //     .markMessageAsRead(message, Cookies.get("token"))
    //     .catch((error) => { });
    // },
    loadMessages() {
      this.customerMessages = null;
      let formData =
        "?user_id=" +
        this.user.id +
        "&lang=" +
        localStorage.language;
      httpServiceCustomer.customerService
        .getMessages(formData, Cookies.get("token"))
        .then(function (response) {
          // handle success
          return response;
        })
        .then((response) => {
          // total no of messages X-Up-Count
          // no of read messages
          this.readMessagesCount = response.headers["x-up-count1"];
          if (!Cookies.get('messagesCount')) {
            Cookies.set('messagesCount', this.readMessagesCount);
          }
          // no of unread messages X-Up-Count2
          this.customerMessages = response.data;
        })
        .catch((error) => {
          // handle error
        });
    },
    hide() {
      this.isOpen = false;
    },
    hideNotification() {
      this.isOpenNotification = false;
    },
    hideCompany() {
      this.isOpenCompany = false;
    },
    logout() {
      Cookies.remove("userLink");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
        params: { loginUserSelected: false },
      });
      this.$emit("sendUserRole", "", "");
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    selectCompany(company) {
      localStorage.removeItem("customer_data");
      window.location.href = "/company";
    },
  },
  computed: {
    selectedCompanyName() {
      return this.user.companies[0].name;
      // return "company name";
      // if (this.company.role === "FAC" || this.company.role === "AFA") {
      // return this.company.company_id + " " + this.company.name;
      // }
      // for (let index in this.user.companies) {
      //   let companyI = this.user.companies[index];
      //   if (this.selectedCompany.company_id === companyI.company_id) {
      //     return companyI.company_id + " " + companyI.name;
      //   }
      // }
      // return "";
    },
  },
  created() {
    switch (this.$route.name) {
      case "customer_faq":
        this.menuSelected.faq = true;
        break;
      case "customer_account":
        this.menuSelected.account = true;
        break;
    }
    this.user = this.getUser();
    // if (Cookies.get('messagesCount')) {
    //   this.readMessagesCount = Cookies.get('messagesCount');
    // } else {
    //   this.loadMessages();
    // }
    // this.selectedCompany = Cookies.getJSON("selectedCompany");
    // if (!this.selectedCompany) {
    //   this.selectedCompany = this.user.companies[0];
    // }
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css" />
<style scoped >
.logo {
  float: left;
  font-family: 'Krona One';
  font-size: 34px;
  color: #fff;
}
.contact-details-wrapper .text {
  color: #fff;
  font-weight: normal;
}

.notification-wrapper img {
  max-width: -webkit-fill-available;
}
</style>
